import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../actions'

import styled from 'styled-components'

import CloseDrawerIcon from '../visuals/CloseDrawer'
import SkipButton from '../visuals/SkipButton'
import PlayButton from '../visuals/PlayButton'
import PauseButton from '../visuals/PauseButton'
import TrackProgress from '../Bottombar/TrackProgress'
import VolumeControl from '../Bottombar/VolumeControl'


const VisualBottombar = styled.div`
  position: fixed;
  bottom: 0px;
  width: 100%;

  background-color: #232323;
  height: 100px;
`

const SidebarToggler = styled.div`
  width: 250px;
  height: 100%;

  font-family: 'Source Sans Pro';
  font-size: 16px;
  line-height: 20px;
  color: #fff;
  cursor: default;
  user-select: none;

  position: relative;

  #button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  #iconWrap {
    float: left;
    margin-right: 8px;
  }
`

const Controls = styled.div`
  height: 100%;
  position: absolute;
  top: 0px;
  left: 250px;
  /* Subtract the width of the SidebarHide component */
  width: calc(100% - 250px);

  .volumeControl {
    position: absolute;
    top: 41px;
    right: 40px;
  }
`

const MidControls = styled.div`
  height: 100%;
  /* Subtract the width of the volume control component */
  width: calc(100% - 250px);
  padding: 20px 80px;
  box-sizing: border-box;

  /* This wrap is to be able to use children with absolute positioning while having the above padding ^ */
  .wrap {
    width: 100%;
    height: 100%;
    position: relative;
  }

  @media (max-width: 1000px) {
    padding: 20px 0px;
  }
`

const TrackTitle = styled.span`
  position: absolute;
  top: 4px;
  left: 40px;

  font-family: 'Source Sans Pro';
  font-size: 16px;
  line-height: 24px;
  color: #fff;
`

const PlaybackControls = styled.div`
  position: relative;
  top: 0px;
  margin: 0 auto;
  width: 116px;
  height: 38px;

  display: flex;
  justify-content: space-between;
  align-items: center;
`

const mapStateToProps = (state) => ({
  sidebarIsOpen: state.sidebar.isOpen,
  trackTitle: `${state.currentTrack.meta.book || ''} ${state.currentTrack.meta.chapter || ''}`,
  trackIsPlaying: state.currentTrack.isPlaying,
})

const mapDispatchToProps = (dispatch) => ({
  onSidebarToggle: () => {
    dispatch(actions.toggleSidebar())
  },

  onTrackToggle: () => {
    dispatch(actions.toggleCurrentTrack())
  },
  playNextTrack: () => dispatch(actions.playNextTrack()),
  playPreviousTrack: () => dispatch(actions.playPreviousTrack())
})

class Bottombar extends Component {
  render () {
    return (
      <VisualBottombar>
        <SidebarToggler>
          <div id="button" onClick={this.props.onSidebarToggle}>
            <span id="iconWrap"><CloseDrawerIcon width="15" height="20" /></span>
            <span>{this.props.sidebarIsOpen ? 'Hide' : 'Show'} Sidebar</span>
          </div>
        </SidebarToggler>

        <Controls>
          <MidControls>
            <div className='wrap'>
              <TrackTitle>{this.props.trackTitle}</TrackTitle>

              <PlaybackControls>
                <SkipButton onClick={this.props.playPreviousTrack} direction='previous' width='15' height='14' />
                { (this.props.trackIsPlaying) ? (
                  <PauseButton onClick={this.props.onTrackToggle} width='38' height='38' />
                ) : (
                  <PlayButton onClick={this.props.onTrackToggle} width='38' height='38' />
                ) }
                <SkipButton onClick={this.props.playNextTrack} direction='next' width='15' height='14' />
              </PlaybackControls>

              <TrackProgress />
            </div>
          </MidControls>
          <div className='volumeControl'>
            <VolumeControl />
          </div>
        </Controls>

      </VisualBottombar>
    )
  }
}

Bottombar = connect(
  mapStateToProps,
  mapDispatchToProps
)(Bottombar)

export default Bottombar



// WEBPACK FOOTER //
// ./src/components/Bottombar/Bottombar.js